import { render, staticRenderFns } from "./enterpriseChannel.vue?vue&type=template&id=59deaa01&scoped=true&"
import script from "./enterpriseChannel.vue?vue&type=script&lang=js&"
export * from "./enterpriseChannel.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseChannel.vue?vue&type=style&index=0&id=59deaa01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59deaa01",
  null
  
)

export default component.exports